import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import { Alert } from "react-bootstrap";
import MiniLoader from "../../../utilityComponents/MiniLoader";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import {
    cartCountUpdate,
    selectedScenarioUuidList,
    selectedScenarioNameList,
    setCurrentPageNumber,
} from "./../../../actions/closeLoop/scenarioCollection/addToCartScenarioCollectionAction";
import { fetchVariationListInfo } from "../../../actions/closeLoop/scenarioCollection/dropDownModalAction";
import ReactPaginate from "react-paginate";

function scenarioCollection(props) {
    // const [editVariationModalPopup, setEditVariationModalPopup] = useState(false);

    let baseUrl = "data:image/png;base64,";

    // if (Object.keys(props.variationInfo).length !== 0) {
    //     if (Boolean(props.variationInfo.aws_enabled) === true) {
    //         baseUrl = "";
    //     }
    // }

    // function editVariationHandler() {
    //     setEditVariationModalPopup(true);
    // }

    // function editVariationModalPopupClose() {
    //     setEditVariationModalPopup(false);
    // }

    const onSelectScenarioVariation = (e, row) => {
        if (props.variationUuidList.indexOf(row.scenario_variation_uuid) !== -1) {
            props.selectedScenarioUuidList(props.variationUuidList);
            props.selectedScenarioNameList(props.variationNameList);
        } else {
            props.selectedScenarioUuidList(
                props.variationUuidList.concat(row.scenario_variation_uuid)
            );
            props.selectedScenarioNameList(
                props.variationNameList.concat(row.scenario_variation_name.split(".zip")[0])
            );
        }
    };

    function onDeselectScenarioVariation(e, row) {
        props.selectedScenarioUuidList(
            props.variationUuidList.filter((i) => i !== row.scenario_variation_uuid)
        );
        props.selectedScenarioNameList(
            props.variationNameList.filter(
                (i) => i !== row.scenario_variation_name.split(".zip")[0]
            )
        );
    }

    function onClickSelectAll() {
        let varUuidList = [...props.variationUuidList];
        let varNameList = [...props.variationNameList];
        if (props.variationInfo.data) {
            props.variationInfo.data.map(function (data) {
                if (props.variationUuidList.indexOf(data.scenario_variation_uuid) !== -1) {
                    console.log("its there");
                } else {
                    varUuidList.push(data.scenario_variation_uuid);
                    varNameList.push(data.scenario_variation_name.split(".zip")[0]);
                }
            });
            props.selectedScenarioUuidList(varUuidList);
            props.selectedScenarioNameList(varNameList);
            document.getElementById("deselect_all_button").disabled = false;
            document.getElementById("select_all_button").disabled = true;
        }
    }

    function onClickDeselectAll() {
        let varUuidList = [...props.variationUuidList];
        let varNameList = [...props.variationNameList];
        if (props.variationInfo.data) {
            props.variationInfo.data.map(function (data) {
                let tempIndex = varUuidList.indexOf(data.scenario_variation_uuid);
                if (tempIndex !== -1) {
                    varUuidList.splice(tempIndex, 1);
                    varNameList.splice(tempIndex, 1);
                }
            });
            props.selectedScenarioUuidList(varUuidList);
            props.selectedScenarioNameList(varNameList);
            document.getElementById("deselect_all_button").disabled = true;
            document.getElementById("select_all_button").disabled = false;
        }
    }

    function cartUpdate() {
        if (props.variationInfo.data !== undefined) {
            if (Object.keys(props.variationInfo.data).length !== 0) {
                const obj = {
                    count: props.variationNameList.length,
                    items: props.variationNameList,
                };
                props.cartCountUpdate(obj);
            } else {
                const obj = {
                    count: 0,
                    items: [],
                };
                props.cartCountUpdate(obj);
            }
        } else {
            const obj = {
                count: 0,
                items: [],
            };
            props.cartCountUpdate(obj);
        }
    }

    useEffect(() => {
        cartUpdate();
    }, [props.variationNameList]);

    const columns = [
        {
            name: "Variation Name",
            selector: "scenarioVariationName",
            sortable: true,
            cell: (row) => (
                <div style={{ flexWrap: "wrap" }}>
                    {row.scenario_variation_name.split(".zip")[0]}
                </div>
            ),
        },
        {
            name: "Variation Description",
            selector: "scenarioVariationDiscription",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.scenario_description}</div>,
            grow: 3,
        },
        {
            name: "Variation Representation",
            selector: "scenarioVariationRepresentation",
            sortable: true,
            cell: (row) => (
                <div style={{ flexWrap: "wrap" }}>
                    <img
                        src={`${baseUrl}${row.scenario_representation.replace(/['"]+/g, "")}`}
                        alt=""
                        style={{ cursor: "pointer" }}
                        width="150"
                        height="100"
                    ></img>
                </div>
            ),
        },
        {
            name: "Variation UUID",
            selector: "scenarioVariationUuid",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.scenario_variation_uuid}</div>,
        },
        {
            name: "Updated On",
            selector: "updatedAt",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.updated_at}</div>,
        },
        {
            name: "Actions",
            selector: "actions",
            sortable: true,
            cell: (row) => (
                <div style={{ flexWrap: "wrap" }}>
                    {/* <div style={{ display: "inline-block", margin: "0.5rem", fontSize: "1.5rem" }}>
                        <button
                            style={{ backgroundColor: "#757AF7" }}
                            onClick={editVariationHandler}

                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    </div> */}
                    <div style={{ display: "inline-block", margin: "0.5rem", fontSize: "1.5rem" }}>
                        {props.variationUuidList.includes(row.scenario_variation_uuid) ? (
                            <button
                                style={
                                    Object.keys(props.scenarioObjectListData).length !== 0
                                        ? { backgroundColor: "#a8abf7" }
                                        : { backgroundColor: "#757AF7" }
                                }
                                onClick={(e) => onDeselectScenarioVariation(e, row)}
                                disabled={Object.keys(props.scenarioObjectListData).length !== 0}
                            >
                                <i className="fas fa-check-square"></i>
                            </button>
                        ) : (
                            <button
                                style={
                                    Object.keys(props.scenarioObjectListData).length !== 0
                                        ? { backgroundColor: "#a8abf7" }
                                        : { backgroundColor: "#757AF7" }
                                }
                                onClick={(e) => onSelectScenarioVariation(e, row)}
                                disabled={Object.keys(props.scenarioObjectListData).length !== 0}
                            >
                                <i className="fas fa-plus-square"></i>
                            </button>
                        )}
                    </div>
                </div>
            ),
        },
    ];
    const customStyles = {
        rows: {
            style: {
                flexWrap: "nowrap",
                minHeight: "70px",
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "70px",
                display: "flex",
                backgroundColor: "white",
                padding: ".75rem",
                verticalAlign: "top",
                borderTop: "1px solid #e9ecef",
                borderBottom: "5px solid #757AF7",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                width: "200%",
                maxWidth: "70%",
                fontSize: "0.98rem",
                textAlign: "center",
                verticalAlign: "top",
                borderTop: "5px solid white",
                justifyContent: "center",
                borderBottom: "0",
            },
        },
    };

    // const para = { EV_SetSpd_Kmph: "30.0" };
    const handlePageClick = (event) => {
        let currentPage = event.selected + 1;
        props.setCurrentPageNumber(event.selected);
        props.variationList(props.baseScenarioSelected, currentPage);
    };

    return (
        <div className="col-lg-12" style={{ padding: "0 1rem" }}>
            <div style={{ padding: "0.5rem", border: "0.2rem solid", borderRadius: "0.5rem" }}>
                {props.loader ? (
                    <MiniLoader />
                ) : props.error ? (
                    <Alert key="danger" variant="danger">
                        {props.error}
                    </Alert>
                ) : (
                    <div className="col-lg-12">
                        {props.variationInfo.data ? (
                            props.variationInfo.data.length > 0 ? (
                                <div style={{ float: "right" }}>
                                    <button
                                        className="btn"
                                        id = "select_all_button"
                                        style={{
                                            backgroundColor: "#757AF7",
                                            color: "#FFFFFF",
                                            border: "0rem",
                                            borderRadius: "0.2rem",
                                            margin: "0 0.5rem",
                                        }}
                                        onClick={onClickSelectAll}
                                        disabled={
                                            (Object.keys(props.scenarioObjectListData).length != 0) || (props.variationInfo.total_variation_count === props.variationNameList.length)
                                        }
                                    >
                                        Select all variations
                                    </button>
                                    <button
                                        className="btn"
                                        id="deselect_all_button"
                                        style={{
                                            backgroundColor: "#757AF7",
                                            color: "#FFFFFF",
                                            border: "0rem",
                                            borderRadius: "0.2rem",
                                            margin: "0 0.5rem",
                                        }}
                                        onClick={onClickDeselectAll}
                                        disabled={
                                            (props.variationUuidList).length == 0 || Object.keys(props.scenarioObjectListData).length !== 0
                                        }
                                    >
                                        Deselect all variations
                                    </button>
                                </div>
                            ) : undefined
                        ) : undefined}

                        <DataTable
                            className="dataTables_wrapper"
                            columns={columns}
                            customStyles={customStyles}
                            data={props.variationInfo.data}
                            defaultSortField="id"
                            defaultSortAsc={false}
                            // pagination
                            // expandableRows
                            // setFilter
                            // selectableRows
                        ></DataTable>
                    </div>
                )}
                {props.variationInfo.data ? (
                    <ReactPaginate
                        previousLabel="<<"
                        breakLabel="..."
                        nextLabel=">>"
                        onPageChange={handlePageClick}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        pageCount={props.variationInfo.pages[props.variationInfo.pages.length - 1]}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={props.currentPageNum}
                    />
                ) : undefined}
            </div>
            {/* {editVariationModalPopup ? (
                <Modal isOpen={editVariationModalPopup}>
                    <ModalHeader>Edit Scenario Variation Details</ModalHeader>
                    <ModalBody>
                        <form>
                            <div className="form-group">
                                  <bold>Edit Scenario Variation is under maintenance</bold>
                            </div>
                            <div className="form-group">
                                <input
                                    className="btn"
                                    style={{ marginLeft: "30%", backgroundColor: "#E3E3E3" , display : "none"}}
                                    type="submit"
                                    value="Submit"
                                />
                                <Button
                                    className="btn"
                                    style={{ marginLeft: "1%", backgroundColor: "red" ,  display : "none"}}
                                >
                                    Reset
                                </Button>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn"
                            style={{ backgroundColor: "#757AF7" }}
                            onClick={editVariationModalPopupClose}
                        >
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            ) : undefined} */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    loader: state.DropDownSubmitReducer.loading,
    error: state.DropDownSubmitReducer.error,
    variationInfo: state.DropDownSubmitReducer.variationListInfo,
    variationUuidList: state.selectedScenarioUuidListData.variationUuidList,
    variationNameList: state.selectedScenarioNameListData.variationNameList,
    baseScenarioSelected: state.BaseScenarioSelectedReducer.baseScenarioSelected,
    scenarioObjectListData: state.addBulkScenariosToListStatus.selectedScenarioObjectList,
    currentPageNum: state.currentPageNumberData.currentPageNumber,
});

const mapDispatchToProps = (dispatch) => ({
    cartCountUpdate: (obj) => dispatch(cartCountUpdate(obj)),
    selectedScenarioUuidList: (variationUuid) => dispatch(selectedScenarioUuidList(variationUuid)),
    selectedScenarioNameList: (variationName) => dispatch(selectedScenarioNameList(variationName)),
    variationList: (baseScenario, page) => dispatch(fetchVariationListInfo(baseScenario, page)),
    setCurrentPageNumber: (currentPageNumber) => dispatch(setCurrentPageNumber(currentPageNumber)),
});

export default connect(mapStateToProps, mapDispatchToProps)(scenarioCollection);
